import modelBaseV2 from "../model-base-v2.model";

/**
 * Site Management Model
 * 
 * Contains all Site Management specific requests
 * 
 * @author CV Leong
 */
const SiteManagementModel = {

  searchSiteManagement: (body) => {
    return modelBaseV2.post('/api/sitemanagement/search', { body });
  },

  exportSiteManagement: (exportType, body, fileName) => {
    return modelBaseV2.postDownload(`/api/sitemanagement/list/export/${exportType}`, { body }, fileName);
  },

  getSiteGeneralInfo: (params) => {
    return modelBaseV2.get('/api/sitemanagement/:siteId/general-info', { params });
  },

  getSiteSoldToList: (params) => {
    return modelBaseV2.get('/api/soldto/:siteId', { params });
  },

  getSiteProductUDFs: (params) => {
    return modelBaseV2.get('/api/sitemanagement/:siteId/product-udf', { params });
  },

  getSiteContactInfo: (params) => {
    return modelBaseV2.get('/api/sitemanagement/:siteId/contact-info', { params });
  },

  addOrUpdateSiteContactInfo: (siteId, body) => {
    return modelBaseV2.post(`/api/sitemanagement/${siteId}/contact-info`, { body });
  },

  removeSiteContactInfo: (params) => {
    return modelBaseV2.post(`/api/sitemanagement/:siteId/contact-info/delete`, { params });
  },

  getSiteAttachmentList: (params) => {
    return modelBaseV2.get('/api/sitemanagement/:siteId/attachments', { params });
  },

  downloadSiteAttachmentList: (params, fileName) => {
    fileName ||= `Attachments for ${params.siteId}.zip`;
    return modelBaseV2.getDownload('/api/sitemanagement/:siteId/attachments/download', { params }, fileName);
  },

  downloadSiteAttachmentByFileId: (params, fileName) => {
    return modelBaseV2.getDownload('/api/sitemanagement/:siteId/attachments/download/:fileId', { params }, fileName);
  },

  addSiteAttachment: (params, formData) => {
    const body = new FormData();
    Object.keys(formData).map(key => {
      body.append(key, formData[key])
    })
    return modelBaseV2.post(`/api/sitemanagement/:siteId/attachments/upload`, { body, params });
  },

  updateSiteAttachment: (params, formData) => {
    const body = new FormData();
    Object.keys(formData).map(key => {
      body.append(key, formData[key])
    })
    return modelBaseV2.post(`/api/sitemanagement/:siteId/attachments/:fileId/update`, { body, params });
  },

  removeSiteAttachment: (params) => {
    return modelBaseV2.post(`/api/sitemanagement/:siteId/attachments/:fileId/delete`, { params });
  },

}

export default SiteManagementModel;